module.exports = require("./da-GL.d.ts");